/* eslint guard-for-in:0 */
/* global PortalL10n */

/**
 * PortalElementSimpleSearch
 */

const {log, error} = require('./PortalLogging')
const PortalApi = require('./PortalApi')
const PortalElementSearch = require('./PortalElementSearch')
const {l10n} = require('./PortalL10n')

const props = [
  'el'
]

module.exports = class PortalElementSimpleSearch extends PortalElementSearch {

  constructor(opts={}) {
    props.forEach(prop => {if (opts[prop] === undefined) throw new Error(`Missing required prop "${prop}" for PortalElementSimpleSearch`)})

    log("new PortalElementSimpleSearch", opts)

    super(opts)
    Object.assign(this, {})

    // Autocomplete
    $(this.target).find('[data-function="ep-query"]').each((i,el) => {
      $(el).autoComplete({
        minChars: 2,
        cache: false,
        source: (term, response) => {
          let words = term.split(/ +/)
          let searchterm = words.pop()
          let suggestRequest = this.buildSuggestRequest('',searchterm)
          this.suggest(suggestRequest)
            .then(data => {
              let matches = data.suggestions.tokens.map(item => {
                let v = words.join(' ')
                if (v.length) {v += ' '}
                v += item.tokens[0]
                return v
              })
              let matches_linked_objects = data.suggestions.linked_objects.map(item => {
                let v = words.join(' ')
                if (v.length) {v += ' '}
                v += item['_standard']['1']['text']['de-DE'] 
                return v
              })
              matches = matches.concat(matches_linked_objects)
              response(matches)
            })
            .catch(error => {response([])})
        }
      })
    })
  }

  init() {}

  searchFromForm(usedForm) {
    this.searchOptionsFromForm(usedForm)
    // Suchfelder einlesen
    this.searchFields = []
    if ($(this.target).find('[data-function="ep-query"]').val().length) {
      $(this.target).find('[data-function="ep-query"]').val().trim().split(/ +/).forEach(st => {
        this.searchFields.push({term: st})
      })
    }
    
    let searchRequest = this.buildSearchRequest()

    // store base search request
    //PortalStorage.setItem('local','searchRequest', searchRequest)

    this.search(searchRequest)
  }
}




//////////////////
// WEBPACK FOOTER
// ./js/PortalElementSimpleSearch.js
// module id = 11
// module chunks = 0